import { useEffect } from "react";

export const useLockBody = (lockCondition, unlockCondition, dep) => {
  useEffect(() => {
    if (lockCondition) document.body.classList.add("lockScroll");
    if (unlockCondition) document.body.classList.remove("lockScroll");
  }, dep);
};
